module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/november-8f3ec1c6e92928bde1b2db903637517d.png";